const contactSubjects = [
  {
    label: 'Customer request',
    value: 'customer-request',
  },
  {
    label: 'Human Resources',
    value: 'human-resources',
  },
  {
    label: 'Finance',
    value: 'finance',
  },
  {
    label: 'Sustainability',
    value: 'sustainability',
  },
]

export default contactSubjects
